
import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import {
  GroupMaintenanceCellScopeVisibility, GroupMaintenanceExtension
} from '../../../backend/backendapi';
import {emptyUUID} from '../../../../util';
import 'vue-good-table/dist/vue-good-table.css';
import CellDropdown from "../../../Maintanence/util/CellDropdown.vue";

@Component({
  components: {
    CellDropdown,
  },
})
export default class GroupCellEditor extends Vue {
  @Prop({required: true})
  readonly group!: GroupMaintenanceExtension;
  
  get selectedCellIds(): number[] {
    return this.group.cellScopeVisibilities.map(m => m.cellId);
  }

  set selectedCellIds(ids: number[]) {
    const newIdsSet = new Set(ids);
    const cellScopeVisibilities = this.group.cellScopeVisibilities;
    const currentIdsSet = new Set(cellScopeVisibilities.map((s) => s.cellId));
    console.log(ids);

    //first add mappings, which were already there
    let newCellMappings = cellScopeVisibilities.filter(m => newIdsSet.has(m.cellId))
    //then add newly added ids (if there are any)
    ids.forEach((id) => {
      if (!currentIdsSet.has(id)) {
        newCellMappings.push(GroupMaintenanceCellScopeVisibility.fromJS({
          id: emptyUUID(),
          cellId: id,
          groupMaintenanceExtensionId: this.group.id,
          cellChildrenVisible: true,
        }));
      }
    });
    
    this.group.cellScopeVisibilities.splice(0);
    this.group.cellScopeVisibilities.push(...newCellMappings);
  }
}
